import React from 'react';
import { Box, Copy, SwatchPicker, Optional, Image } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import { stripMarkdownHeading } from '../../utils/markdown';
import themeStyles from './styles/ColorSwatches.styles';
import ColorUpChargePrice from '../ConfigureBap/shared/ColorSwatchCarousel/ColorUpChargePrice';
const Container = themeStyles.apply(Box, 'Container');
const ColorName = themeStyles.apply(Copy, 'ColorName');
const ColorSwatches = ({ swatches, testIds }) => (React.createElement(React.Fragment, null,
    swatches.map(({ name, key }, index) => (React.createElement(ColorName, { key: key, size: "extraSmall", "data-testid": `${testIds[index]}-color-name` }, compiler(stripMarkdownHeading(name))))),
    swatches.map(({ name, color, image, key }, index) => {
        const swatchColor = color ? { name, color } : { name, image: React.createElement(Image, { ...image }) };
        return React.createElement(SwatchPicker, { key: key, swatch: swatchColor, "data-testid": testIds[index], icon: "checkmark", ml: "s" });
    }),
    swatches.map(({ colorUpCharge, key }, index) => {
        const { price, payment, paymentFrequency, tooltipLabel } = colorUpCharge !== null && colorUpCharge !== void 0 ? colorUpCharge : {};
        return (
        // for cash, only payment is zero
        React.createElement(Optional, { when: price || payment, key: key },
            React.createElement(Container, { "data-testid": `${testIds[index]}-up-charge`, gridColumnStart: index + 1 },
                React.createElement(ColorUpChargePrice, { price: price, payment: payment, paymentFrequency: paymentFrequency, tooltipLabel: tooltipLabel }))));
    })));
export default ColorSwatches;
